<template>
    <div class="border-b py-3">
        <button class="block w-full text-left relative hover:md:text-green group transition duration-200"  @click="showContent = !showContent">
            <div class="relative top-0.5">
                <slot name="header"></slot>
            </div>

            <svg v-if="!showContent" :class="{'max-md:hidden': hideArrowOnMobile}" class="absolute -top-[0.3rem] md:-top-[0.3rem] right-0" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><path stroke="#000" class="group-hover:md:stroke-green transition duration-200" stroke-width="2" d="M30 15H0m15 15V0"/></svg>

            <svg v-if="showContent" :class="{'max-md:hidden': hideArrowOnMobile}" class="absolute -top-[0.3rem] md:-top-[0.3rem] right-0" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 3"><path stroke="#000" :class="{'---max-md:stroke-green': showContent}" class="group-hover:md:stroke-green transition duration-200" stroke-width="2" d="M30 1.5H0"/></svg>
        </button>
        <div class="content" ref="content" :class="{'show': showContent}">
            <div class="pt-6 pb-3">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
const emit = defineEmits(['isOpen'])
const showContent = ref(false)
const content = ref(null)

const props = defineProps({
    hideArrowOnMobile: {
        type: Boolean,
        required: false
    }
});

watch(() => showContent.value, (val) => {
    if (val) {
        content.value.style.height = content.value.scrollHeight + 'px'
        emit('isOpen', true)
    } else {
        content.value.style.height = '0px'
        emit('isOpen', false)
    }
})
</script>

<style scoped lang="scss">
.content {
    @apply h-0 overflow-hidden transition-all duration-400;
}
</style>